import { orderInfoService } from "@/services/orderInfoService";
import { useAuthStore } from "@/stores";

const HTTP_SCHEME = /^https?:\/\//i;

export function useDocumentLink() {
  const authStore = useAuthStore();

  // A failed mint must never navigate a provider (external viewer, LAM-5263) to the raw stored URL —
  // the fresh-mint path is how they read documents; on failure they see an error, not a stale link.
  // Callers may still force behaviour with an explicit `fallbackToStoredLink`. Returns whether a doc opened.
  async function openDocument(orderKey, storedLink, { fallbackToStoredLink } = {}) {
    const allowFallback = fallbackToStoredLink ?? !authStore.userInfo?.isProvider;
    if (!storedLink || !HTTP_SCHEME.test(storedLink)) return false;
    if (!orderKey) {
      window.open(storedLink, "_blank", "noopener");
      return true;
    }
    const win = window.open("", "_blank");
    try {
      const { url } = await orderInfoService.getFreshDocumentLink(orderKey, storedLink);
      if (win) win.location.replace(url);
      else window.open(url, "_blank", "noopener");
    } catch {
      if (!allowFallback) {
        if (win) win.close();
        return false;
      }
      if (win) win.location.replace(storedLink);
      else window.open(storedLink, "_blank", "noopener");
    }
    return true;
  }

  return { openDocument };
}
